/**
 * Zod schema for entity extraction output.
 * Used with structured outputs to get guaranteed-valid JSON from the LLM.
 * Mirrors RawExtractedEntity in llm-adapter.ts.
 */

import { z } from 'zod';

// Must match EntityType in src/intelligence/entities/types.ts
const ENTITY_TYPES = [
  'PERSON',
  'ORGANIZATION',
  'LOCATION',
  'ASSET',
  'EVENT',
  'INDICATOR',
  'SOURCE',
] as const;

export const ExtractedEntitySchema = z.object({
  name: z.string().min(1),
  type: z.enum(ENTITY_TYPES),
  description: z.string().optional(),
  aliases: z.array(z.string()).optional().default([]),
  properties: z.record(z.string(), z.unknown()).optional().default({}),
  extractionQuote: z.string().min(1),
  confidence: z.number().min(0).max(1),
});

export const EntityExtractionResultSchema = z.object({
  entities: z.array(ExtractedEntitySchema),
});

export type ExtractedEntityOutput = z.infer<typeof ExtractedEntitySchema>;
